import { SubscriptionRequestTable } from "api/interfaces/subscription.interface";
import CpRequestHistoryItem from "./CpRequestHistoryItem";
import { CpRequestItemStyled } from "./CpRequestStyled";

type Props = {
  requestList: SubscriptionRequestTable[];
  onConfirm: (row: SubscriptionRequestTable) => void;
  onOpenEmailToRequesterModal: (email: SubscriptionRequestTable) => void;
};

export default function CpRequestHistory(props: Props): JSX.Element {
  return (
    <CpRequestItemStyled.Wrapper>
      {props.requestList.map((request: SubscriptionRequestTable) => {
        return (
          <CpRequestHistoryItem
            request={request}
            onConfirm={() => {
              props.onConfirm(request);
            }}
            onOpenEmailToRequesterModal={() =>
              props.onOpenEmailToRequesterModal(request)
            }
          />
        );
      })}
    </CpRequestItemStyled.Wrapper>
  );
}
